export default __webpack_public_path__ + "static/media/yandex.c56fa258.png";